import { useCallback } from "react";
import { debounce } from "lodash";

export function useDebounce(callback, delay, options, dependencies = []) {
  return useCallback(debounce(callback, delay, options), dependencies); // eslint-disable-line react-hooks/exhaustive-deps
}
